import React, { useEffect, useRef, useState } from "react";
import Swipe from "react-easy-swipe";
import { observer } from "mobx-react-lite";
import Game from "../../store/Game";
import Swiper from "../../store/Swiper";
import Ellipses from "../../components/Ellipses";
import ProgressBar from "./components/ProgressBar";
import SwiperActions from "./components/SwiperActions";
import SwiperImage from "./components/SwiperImage";
import LastAnswer from "./components/LastAnswer";
import CardTitle from "./components/CardTitle";
import SwiperIndicate from "./components/SwiperIndicate";
import useViewController from "./viewController";
import useController from "./controller";
import TopMobileModal from "../../modals/TopMobileModal";
import HelpCompromiseModal from "../../modals/HelpCompromiseModal";
import MobileModalLastAnswers from "./components/MobileModalLastAnswers";
import RestoreDemoProgressModal from "../../modals/RestoreDemoProgressModal";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Butterflies from "../../components/Butterflies";
import BaseIcon from "../../components/BaseIcon";
import BaseSpinner from "../../components/BaseSpinner";
import UsingPrevGameAnswer from "../../modals/UsingPrevGameAnswer";
import WantToKnowModal from "../../modals/WantToKnowModal";
import HandIcon from "../../assets/images/icon_hand_1.png";
import ROUTES from "../../utils/routes.js";
import ChooseYourGenderModal from "../../modals/ChooseYourGenderModal";
import "./style.scss";
import WrapperPage from "../../components/WrapperPage";
import useAuth from "../../hooks/useAuth";
import is from "is_js";
import INTOUCH_API from "../../services/Api";
import { isWebView } from "../../utils/helpers";
import { shopStore } from "../../store/Shop";
import { shouldPulseShopIcon } from "../../utils/shopProducts";
import InGameShopDemo from "../../components/InGameShopDemo";

const mountedStyle = { animation: "inAnimation 0.5s ease-in" };
const unmountedStyle = {
  animation: "outAnimation 0.5s ease-out",
  animationFillMode: "forwards",
};

export default observer(function InGamePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isExtendedSet = location.state?.setType === "EXTENDED_57";
  const countCardRef = useRef(0);

  const {
    onFeedbackSwipe,
    createInsightForm,
    isInsightLoading,
    isCardsLoading,
  } = useController(countCardRef);

  const {
    countCard,
    isToRight,
    isToLeft,
    isToTop,
    onSwipeStart,
    opacityCard,
    completedCards,
    isPositive,
    isNeutral,
    isNegative,
    isSwiping,
    isOpen,
    toggleModal,
    isAnsweredCardsExist,
    onSwipeMove,
    onSwipeEnd,
    positiveSwipe,
    negativeSwipe,
    neutralSwipe,
    backSwipe,
    forwardSwipe,
    calculatePercentProgress,
    resetGameProgress,
    onRestoreGameHistory,
    onUsePrevGameAnswer,
    isAnswerAllLoading,
  } = useViewController(onFeedbackSwipe);

  const wrapperRef = useRef(null);
  const imgRef = useRef(null);
  const [imageDims, setImageDims] = useState();
  const [imageLoaded, setImageLoaded] = useState(false);

  // Синхронизируем countCard с ref
  useEffect(() => {
    countCardRef.current = countCard;
  }, [countCard]);
  const currentGame = Game.game;
  const { token } = useAuth();
  const isMobile = is.mobile();

  const game = Game.game;

  useEffect(() => {
    (async () => {
      const gameEvent = Game.endGameEvent;
      const event = gameEvent.find((e) => e.gameId === game.id);
      if (event) {
        await INTOUCH_API.requestManager("game_notification", {
          id: event.id,
          isViewed: true,
        });
        await INTOUCH_API.requestManager(
          "get_game_events",
          null,
          (response) => {
            Game.setGameEventsData(response.data);
          }
        );
      }
    })();
  }, []);

  useEffect(() => {
    const handleTouchMove = (e) => {
      // item 3b: этот глобальный preventDefault держит страницу игры от прокрутки при
      // свайпе карточек, но заодно глушил скролл ВНУТРИ модалки магазина — список стран
      // на моб. Chrome «не скроллился». Пропускаем блоки, которые прокручиваются сами.
      if (e.target?.closest?.("[data-allow-touch-scroll]")) return;
      if (e.cancelable) {
        e.preventDefault();
      }
    };

    document.body.addEventListener("touchmove", handleTouchMove, {
      passive: false,
    });

    return () => {
      document.body.removeEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    };
  }, []);

  useEffect(() => {
    const calc = () => {
      const ih = window.innerHeight || document.documentElement.clientHeight;
      const iw = window.innerWidth || document.documentElement.clientWidth;
      if (iw > 576) return;
      if (imageLoaded) {
        // 07.10: запас снизу под панель браузера. Иконки (инфо/анкета/магазин) были
        // вровень с нижним краем, на iPhone их перекрывала панель Safari: тап по
        // анкете попадал в панель («не нажимается»), а прокрутка в игре отключена.
        const bottomGap = isWebView() ? 0 : is.ios() ? 48 : 16;
        const reserve = (!isWebView() ? 84 : 119) + bottomGap;
        if (ih <= wrapperRef.current.offsetHeight + reserve) {
          const diff = wrapperRef.current.offsetHeight + reserve - ih;
          setImageDims({
            height: Math.round(imgRef.current.offsetHeight - diff),
          });
        }
      }
    };

    calc();

    window.addEventListener("resize", calc);
    window.addEventListener("orientationchange", calc);
    return () => {
      window.removeEventListener("resize", calc);
      window.removeEventListener("orientationchange", calc);
    };
  }, [imageLoaded]);

  return (
    <div
      className={[
        "in-game-page centering-page",
        // визуальное отличие свайпера +57 (ТЗ: «оформлены визуально немного по-другому»)
        isExtendedSet ? "in-game-page--ext57" : "",
      ].join(" ")}
    >
      {/*{process.env.NODE_ENV === "development" && (
        <BaseButton
          loading={isAnswerAllLoading}
          onClick={answerRandomAll}
          className="in-game-page__debug-btn"
        >
          [DEBUG] ANSWER ALL
        </BaseButton>
      )}*/}
      <WrapperPage backBtn burgerMenu={!!token} loginBtn={!token}>
        <InGameShopDemo />
        <TopMobileModal toggleModal={toggleModal} isOpen={isOpen} />
        <HelpCompromiseModal />
        <WantToKnowModal></WantToKnowModal>
        <RestoreDemoProgressModal
          resetGameProgress={resetGameProgress}
          onRestoreGameHistory={onRestoreGameHistory}
        />
        <UsingPrevGameAnswer onUsePrevGameAnswer={onUsePrevGameAnswer} />
        <ChooseYourGenderModal></ChooseYourGenderModal>
        <Butterflies className="in-game-page-butterflies" countEllipses={2} />
        <Ellipses className="in-game-page-ellipses" countEllipses={1} />
        {isCardsLoading && (
          <div className="in-game-page__main in-game-page__main-loader">
            <BaseSpinner />
          </div>
        )}
        {/* gameHistory содержит ответы ВСЕХ наборов игры — сравниваем только карты
           текущей колоды (как в checkEndGameOnInit/onRestoreGameHistory), иначе
           88 чужих ответов (31 база + 57 ext) блокировали свайпер плейсхолдером */}
        {Game.cards.length > 0 &&
        Game.gameHistory.filter(
          (h) =>
            h.answer > 0 && Game.cards.some((card) => card.id === h.questionId)
        ).length === Game.cards.length ? (
          <div className="in-game-page__main in-game-page__main-loader">
            Карточки выбраны
          </div>
        ) : (
          <div ref={wrapperRef} className="in-game-page__main">
            <ProgressBar
              calculatePercentProgress={calculatePercentProgress}
              countCard={countCard}
              totalCards={Game.cards.length}
              isLoading={isCardsLoading}
            />
            <div className="in-game-page__main__swipe-wrapper">
              {Game.cards.map((card, i) => {
                return (
                  i === countCard && (
                    <div key={card.id} className="main-swiper-wrapper">
                      <div
                        style={i === countCard ? mountedStyle : unmountedStyle}
                        className="in-game-page__main__swipe-wrapper__wrapper"
                      >
                        <Swipe
                          allowMouseEvents={true}
                          onSwipeStart={onSwipeStart}
                          onSwipeEnd={onSwipeEnd}
                          onSwipeMove={onSwipeMove}
                          style={{
                            transform: `translate(${Swiper.transform.x}px, ${Swiper.transform.y}px) rotate(${Swiper.transform?.rotate}deg)`,
                          }}
                          className={`in-game-page__main__swipe-card ${
                            isPositive && "positive-swipe-transform"
                          }
                    ${isNegative && "negative-swipe-transform"}
                    ${isNeutral && "neutral-swipe-transform"}
                    ${isSwiping ? "is-swiping" : ""}
                    `}
                        >
                          {i === 0 && shopStore.isShopFingerDemoFinished && (
                            <div className="swipe_hand">
                              <img src={HandIcon} alt="" draggable="false" />
                            </div>
                          )}
                          <div className="in-game-page__main__swipe-card__wrapper">
                            <SwiperImage
                              imgRef={imgRef}
                              imageDims={imageDims}
                              setImageLoaded={setImageLoaded}
                              card={card}
                              isNeutral={isNeutral}
                              isNegative={isNegative}
                              isPositive={isPositive}
                              opacityCard={opacityCard}
                            />
                            <SwiperIndicate
                              isNegative={isNegative}
                              isPositive={isPositive}
                              isNeutral={isNeutral}
                              isToRight={isToRight}
                              isToTop={isToTop}
                              isToLeft={isToLeft}
                            />
                          </div>
                        </Swipe>
                        <CardTitle card={card} />
                        <LastAnswer className="half-opacity" card={card} />
                      </div>
                      <SwiperActions
                        countCard={countCard}
                        isSwiping={isSwiping}
                        isToRight={isToRight}
                        isNegative={isNegative}
                        isNeutral={isNeutral}
                        isToTop={isToTop}
                        isToLeft={isToLeft}
                        isPositive={isPositive}
                        backSwipe={backSwipe}
                        positiveSwipe={positiveSwipe}
                        neutralSwipe={neutralSwipe}
                        negativeSwipe={negativeSwipe}
                        isAnsweredCardsExist={isAnsweredCardsExist}
                        forwardSwipe={forwardSwipe}
                        card={card}
                        completedCards={completedCards}
                      />
                      <div className="main-swiper-wrapper__bottom-icons">
                        <div className="main-swiper-wrapper__bottom-icons__item main-swiper-wrapper__bottom-icons__info">
                          <BaseIcon name="info_icon" />
                        </div>
                        <div className="main-swiper-wrapper__insight-icon main-swiper-wrapper__bottom-icons__item">
                          {isInsightLoading ? (
                            <BaseSpinner />
                          ) : (
                            <BaseIcon
                              onClick={() =>
                                // 28.09: гость (без регистрации) — на публичную страницу
                                // описания с инструкцией и покупкой. Раздел анкеты закрыт
                                // RequireAuth: гостя выкидывало на регистрацию, а «Назад»
                                // возвращал в раздел, откуда снова выкидывало, — петля.
                                // item 17.09: залогиненный с некупленной игрой — в раздел.
                                !token
                                  ? navigate(ROUTES.INSIGHT_DESCRIPTION)
                                  : Game.game.type === "DEMO"
                                  ? navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)
                                  : createInsightForm(card)
                              }
                              name="insight_form_icon"
                            />
                          )}
                        </div>
                        <div
                          className={`main-swiper-wrapper__bottom-icons__item main-swiper-wrapper__bottom-icons__shop ${
                            shouldPulseShopIcon(shopStore.selectedCountry, card)
                              ? "main-swiper-wrapper__bottom-icons__shop--pulse"
                              : ""
                          }`}
                        >
                          <BaseIcon
                            name="shop_icon2"
                            onClick={() => shopStore.open(card)}
                          />
                        </div>
                      </div>
                      <MobileModalLastAnswers card={card} />
                    </div>
                  )
                );
              })}
            </div>
            <div></div>
            {/*<div className="in-game-page__main__exit">*/}
            {/*  {currentGame && currentGame?.demo ? (*/}
            {/*    <BaseTextButton onClick={() => navigate(ROUTES.PAYMENT_PAGE)}>*/}
            {/*      {t("buy_game")}*/}
            {/*    </BaseTextButton>*/}
            {/*  ) : (*/}
            {/*    <BurgerMenu />*/}
            {/*  )}*/}
            {/*</div>*/}
          </div>
        )}
      </WrapperPage>
    </div>
  );
});
